export const JMP: MTG.Set = {
  id: 'JMP',
  name: 'Jumpstart',
  wiki: 'https://mtg.fandom.com/wiki/Jumpstart',
  boosters: [],
}
